module.exports = __webpack_public_path__ + "static/media/bay_park_small.0202e7a7.jpg";